/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_CountryInputs */

const de__field_country = /** @type {(inputs: _Field_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Land ungleich Deutschland`)
};

/**

* @param {_Field_CountryInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_country = /** @type {((inputs?: _Field_CountryInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_CountryInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_country(inputs)
});